import React, { useCallback, useState } from 'react'

import { Button, Input, Row, Span } from 'components'
import { MagnifyingGlassIcon } from 'components/Icons'

import { TableVisaoIndividual } from '..'

import { useMovement } from 'hooks'
import { Entity } from 'pages/Supplier/MovMensal/types'
import { createArrayCopy } from 'utils/functions'

export interface IVisaoTableAnterior {
  listaAnterior: Entity[]
  handleFilterEfetivos: (_query: string, _entity: Entity) => void
}

const VisaoTableAnterior: React.FC<IVisaoTableAnterior> = ({
  listaAnterior,
  handleFilterEfetivos
}) => {
  const {
    movState,
    parametrization,
    setMovState,
    handleBlock,
    dataAtuacaoInvalida,
    competenciaSelecionada,
    isSemMobilizacao,
    isSomenteCompartilhado,
    setBlockVerifyIndividual
  } = useMovement()

  const [pesquisaGeral, setPesquisaGeral] = useState<string>('')

  const disableReplicateToCurrent = useCallback((): boolean => {
    const enableButton = false
    const disableButton = true

    if (
      [isSomenteCompartilhado, isSemMobilizacao].includes(true) ||
      dataAtuacaoInvalida
    ) {
      return disableButton
    }

    return enableButton
  }, [isSomenteCompartilhado, isSemMobilizacao, dataAtuacaoInvalida])

  return (
    <>
      <Row alignItems="center" justifyContent="space-between">
        <Span text="Última competência" fontWeight="700" fontSize="16px" />
        <Input
          placeholder="Pesquisa Geral"
          label="Pesquisa"
          inputIcon={<MagnifyingGlassIcon />}
          value={pesquisaGeral}
          onChange={(e) => setPesquisaGeral(e.target.value)}
        />
      </Row>
      <TableVisaoIndividual
        tableData={listaAnterior?.filter((data) =>
          handleFilterEfetivos(pesquisaGeral, data)
        )}
        isCompetenciaAtual={movState.isCompetenciaAtual}
        dadosParametrizacao={parametrization}
        bloquearAcoes={true} //NUNCA VAI PODER DELETAR
      />
      <Row justifyContent="flex-end" alignItems="center">
        <Button
          text="Replicar Para Atual"
          disabled={disableReplicateToCurrent()}
          onClick={() => {
            handleBlock(true, 'visaoTotal')
            setBlockVerifyIndividual(false)

            const cpy = createArrayCopy(movState.compAnterior)
            const newList = cpy
              .filter(
                (el: Entity) =>
                  el.cdStatus.toUpperCase() !== 'DEMITIDO' && el.cdStatus.toUpperCase() !== 'TRANSFERIDO'
              )
              .map((el: Entity) => {
                el.nuMesAnoCompetencia = competenciaSelecionada
                el.nuAnoMesCompetencia = competenciaSelecionada
                return el
              })
            setMovState((old) => ({ ...old, compAtual: newList }))
          }}
        />
      </Row>
    </>
  )
}

export default VisaoTableAnterior
